<template></template>
<script setup>
import { onMounted } from 'vue'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({ items: { type: Array } })

const store = usePaletteBuilderStore()
const { setItems } = store

onMounted(() => setItems(props.items))
</script>
